'use strict';
import CreditCardListController from './credit-card-list.controller';
import CreditCardForm from '../forms/account/credit-card';
import ngMaterial from 'angular-material';
import CreditCardService from './credit-card.service';
import AddressService from '../forms/account/address/address.service';
export default angular.module('directives.creditCardList', [CreditCardForm, ngMaterial, 'dialog'])
    .service('CreditCardService', CreditCardService)
    .service('AddressService', AddressService)
    .controller('CreditCardListController', CreditCardListController)
    .component('creditCardList', {
    template: require('./credit-card-list.html'),
    controller: CreditCardListController
})
    .filter('creditCardType', function () {
    return function (item) {
        switch (item) {
            case 0:
                return 'Visa';
            case 1:
                return 'Mastercard';
            case 2:
                return 'American Express';
            case 3:
                return 'Discover';
            default:
                return 'Unknown';
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map